import { Injectable } from '@angular/core';
import { forkJoin, Observable } from 'rxjs';
import { PlanningService } from '@obo-main/services/plannings/planning.service';
import { BuildingService } from '@obo-dashboard/services/building.service';

@Injectable()
export class FinishWizardService {
    constructor(private planningService: PlanningService, private buildingService: BuildingService) {}

    public undoSaving(projectId: number, buildingId: number, planningId: number): Observable<any> {
        return forkJoin([
            this.planningService.deletePlanning(projectId, buildingId, planningId),
            this.buildingService.deleteBuilding(projectId, buildingId)
        ]);
    }
}
